import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const TableContainer = styled.ul`
  li {
    border-radius: ${theme.border.radius.small};
    color: ${theme.colors.gray6};
    padding: 1rem 1.875em;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.6em;
    font-size: max(0.9rem, 0.8vw);
  }

  @media all and (max-width: ${theme.grid.tablet.breakpoint}) {
    li {
      display: block;
    }
  }
`;

export const TableHeader = styled('li', { position: String })`
  background-color: ${theme.colors.gray3};
  font-size: inherit;
  letter-spacing: 0.01em;
  position: ${(props) => props.position ?? 'static'};

  @media all and (max-width: ${theme.grid.tablet.breakpoint}) {
    display: none !important;
  }
`;

export const TableRow = styled.li`
  background-color: #ffffff;
  box-shadow: ${theme.shadow.lv1};

  &.click {
    &:hover {
      cursor: pointer;
      box-shadow: ${theme.shadow.lv3};
    }
  }
`;

export const Col = styled.div`
  flex-basis: 100%;
  display: flex;
  align-items: center;
  user-select: none;
  font-size: inherit;
  span {
    display: flex;
    align-items: center;
    margin-left: 0.5em;

    svg {
      width: 1.4em;
      height: auto;

      &.isHover {
        transform: scale(1);

        &:hover {
          cursor: pointer;
          transform: scale(1.2);
        }
      }
    }
  }

  &.orderStyle {
    text-decoration: underline;
  }

  p.text {
    display: block;
    max-width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media all and (max-width: ${theme.grid.tablet.breakpoint}) {
    display: flex;
    padding: 0.625em 0;

    &:before {
      color: ${theme.colors.gray5};
      padding-right: 0.625em;
      content: attr(data-label);
      flex-basis: 50%;
      text-align: right;
    }
  }
`;

export const ContentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.2rem;

  svg {
    width: 1.4rem;
    height: auto;
    transform: scale(1);

    :hover {
      transform: scale(1.1);
      cursor: pointer;
    }

    &.rotate {
      transform: rotateX(180deg);
    }
  }
`;

export const ColText = styled('p', { maxWidth: String })`
  display: block;
  max-width: ${(props) => props.maxWidth ?? '50%'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.isHidden {
    display: none 
  }
`;
